import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { getSession, getSessionClinicalNotes, Session } from '@uplift/api';
import { BaseQueryOpts } from '../baseTypes';
import { useCptCodesByIdsQuery } from '../claimCorrections.queries';
import { useDiagnosesByIdsQuery } from './diagnosis.queries';


export const useSessionClinicalNoteQuery = (sessionId: string, opts?: BaseQueryOpts) => {
  return useQuery([ 'session', sessionId, 'clinicalNote' ], async () => {
    const clinicalNoteResponse = await getSessionClinicalNotes(sessionId);

    return clinicalNoteResponse.data;
  }, opts);
};

export const useSessionQuery = (sessionId: string, opts?: BaseQueryOpts) => {
  return useQuery([ 'session', sessionId ], async () => {
    const response = await getSession(sessionId);

    return response.data.session;
  }, opts);
};

export const useSessionCptCodesQuery = (session: Session, opts?: BaseQueryOpts) => {
  const cptCodeIds = React.useMemo(() => {
    return [
      ...[ session?.cptCodeId ],
      ...(session?.addonCptCodeIds || [])
    ].filter(Boolean) as string[];
  }, [ session ]);

  return useCptCodesByIdsQuery(cptCodeIds, {
    ...opts,
    enabled: opts.enabled ?? !!cptCodeIds.length,
  });
};

export const useSessionDiagnosisQuery = (session: Session, opts?: BaseQueryOpts) => {
  return useDiagnosesByIdsQuery(session?.diagnosisIds ?? [], {
    ...opts,
    enabled: opts.enabled ?? !!session?.diagnosisIds?.length
  });
};
